import styled from "@emotion/styled";
import {
  Col,
  Dropdown,
  MenuProps,
  Radio,
  Tag,
  Typography,
} from "antd";
import { FC, useState } from "react";
import { MoreOutlined } from "@ant-design/icons";
import { AddressData } from "../interface/address.interface";
import { convertTransport } from "utils/convertData";


interface RetailAddressCardProps {
  data: AddressData | undefined;
  index: number;
  handleRemoveItem?: (target: string) => void;
  showEdit?: (id: string) => void;
  changeDefault?: (id: string) => void;
  canUpdate?: boolean;
}


const RetailAddressCard: FC<RetailAddressCardProps> = (
  { 
    data,
    index, 
    handleRemoveItem, 
    showEdit, 
    changeDefault, 
    canUpdate,
  }) => { 
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const handleDropdownVisibleChange = (visible: boolean) => {
    setIsDropdownOpen(visible);
  };

  const removeEvent = (index: string) => {
    if (handleRemoveItem) {
      handleRemoveItem(index)
    }
    setIsDropdownOpen(false);
  };
 
  const handleShowEdit = (id: string) => {
    if (showEdit) {
      showEdit(id);
    }
    setIsDropdownOpen(false);
  };

  const handleRadioChange = () => {
    if (changeDefault) {
      changeDefault(data?.address_id ?? data?.temp_id ?? ''); 
    }
  };

  const items: MenuProps["items"] = [
    {
      key: "0",
      label: <div onClick={()=>  handleShowEdit(data?.address_id ?? data?.temp_id ?? '')} >แก้ไข</div>, 
    },
    {
      key: "1",
      label: <div onClick={() => removeEvent(data?.address_id ?? data?.temp_id ?? '')}>ลบ</div>, 
    },
  ];

  return (
  <Col sm={12} md={8} xl={8} span={24} style={{ padding:'5px'}}>
    <CardContainer>
      {data?.last_address && (
        <FixedTag color="magenta">ที่อยู่จัดส่งล่าสุด</FixedTag>
      )}
      <ImageWrapper>
        <Radio value={data?.address_id ?? data?.temp_id} onChange={handleRadioChange}/>
      </ImageWrapper>
      <Content>
        <TextWrapper> 
          <Typography.Text style={{ fontWeight: 400 ,fontSize: 13 }}>
            {convertTransport(data?.transport_type)}
          </Typography.Text>
          <Typography.Text className="text-order-product-name">
            { data?.is_default && <Tag >ที่อยู่เริ่มต้น</Tag> } 
            {/* icon={locationIcon} */}
          </Typography.Text>
        </TextWrapper>


        <TextWrapper>
          <Typography.Text className="text-order-product-name">
            ชื่อ :
          </Typography.Text>
          <Typography.Text className="text-order-product-name">
            {data?.address_name} 
          </Typography.Text>
        </TextWrapper>

        <TextWrapper>
          <Typography.Text className="text-order-product-name">
            เบอร์โทรศัพท์ :
          </Typography.Text>
          <Typography.Text className="text-order-product-name">
            {data?.address_telephone} 
          </Typography.Text>
        </TextWrapper>

        <TextWrapper>
          <Typography.Text className="text-order-product-name">
            ที่อยู่ : {data?.line_1} {data?.line_2}
          </Typography.Text>
        </TextWrapper>

        <TextWrapper>
          <Typography.Text className="text-order-product-name">
           {data?.province_name} {data?.district_name} {data?.sub_district_name} {data?.post_code}
          </Typography.Text>
        </TextWrapper>
        <TextWrapper>
          <Typography.Text className="text-order-product-name">
           หมายเหตุ: {data?.address_remark ?? data?.remark}
          </Typography.Text>
        </TextWrapper>
      </Content>
      {canUpdate && (
        <MoreOptionsContainer>
        <Dropdown
          menu={{ items }}
          trigger={['click']}
          open={isDropdownOpen}
          onOpenChange={handleDropdownVisibleChange}
        >
          <MoreOptions>
            <MoreOutlined />
          </MoreOptions>
        </Dropdown>
      </MoreOptionsContainer>
      )}


    </CardContainer>
  </Col>
  );
};

export default RetailAddressCard;

const ImageWrapper = styled.div`
 `;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;  
`;

const CardContainer = styled.div`
  display: flex;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 16px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const MoreOptionsContainer = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
`;


const MoreOptions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #e0e0e0;
  }
`;

const FixedTag = styled(Tag)`
  position: absolute;
  top: 20px;
  right: 20px;
`;